const INTERACTIVE_POINTER_TARGET_SELECTOR = [
  "a",
  "button",
  "input",
  "textarea",
  "select",
  "option",
  "label",
  "summary",
  "[contenteditable]:not([contenteditable='false'])",
  "[role='button']",
  "[role='textbox']",
  "[role='searchbox']",
  "[role='combobox']",
  "[role='listbox']",
  "[role='option']",
  "[role='menuitem']",
  "[role='slider']",
  "[role='spinbutton']",
  "[role='checkbox']",
  "[role='radio']",
  "[role='switch']",
].join(", ")

/** True when a pointer gesture should stay with the target (forms, links, controls). */
export const isInteractivePointerTarget = (
  target: EventTarget | null
): boolean => {
  if (!(target instanceof Element)) return false
  return Boolean(target.closest(INTERACTIVE_POINTER_TARGET_SELECTOR))
}
